import { useMutation } from '@tanstack/react-query';
import { patchCenterVatPolicy } from './api';
import { PatchVatPolicyBody } from './types';

export const usePatchCenterVatPolicy = () => {
    return useMutation({
        mutationFn: ({
            centerId,
            body,
        }: {
            centerId: string;
            body: PatchVatPolicyBody;
        }) => patchCenterVatPolicy({ centerId, body }),
    });
};
